<template>
  <div class="auth-page-forms">
    <h1 class="auth-page__title">Вход</h1>
    <form
      class="auth-page__form"
      v-on:submit.prevent="login">
      <input-email
        label="E-mail"
        v-bind:input-classes="{ 'auth-page__field-input': true }"
        v-model="email" />
      <input-secret
        label="Пароль"
        ref="inputPassword"
        v-bind:input-classes="{ 'auth-page__field-input': true }"
        v-bind:violations="errors"
        v-model="password" />
      <removable-feature feature="forgot-password">
        <router-link
          v-bind:to="{ name: 'ForgotPassword', params: { initialEmail: email } }"
          class="auth-page__link">Забыли пароль?</router-link>
      </removable-feature>
      <button
        type="submit"
        class="auth-page__button"
      >Войти</button>
    </form>
    <removable-feature feature="registration">
      <div class="auth-page__description">
        Нет аккаунта?
        <router-link
          v-bind:to="{ name: 'Registration' }"
          class="">Зарегистрироваться</router-link>
      </div>
    </removable-feature>
  </div>
</template>
<script>
import { USER_REQUEST } from '@/store/actions/user';
import { AUTH_REQUEST } from '@/store/actions/auth';
import InputEmail from '@/components/InputEmail.vue';
import InputSecret from '@/components/InputSecret.vue';
import RemovableFeature from '@/components/RemovableFeature.vue';
import { VUE_APP_TITLE } from '@/transformEnv';

export default {
  components: {
    InputEmail,
    InputSecret,
    RemovableFeature,
  },
  data() {
    return {
      email: this.initialEmail || '',
      password: '',
      errors: [],
    };
  },
  methods: {
    async login() {
      const { email, password } = this;
      try {
        this.errors = [];
        const { redirect } = await this.$store.dispatch(AUTH_REQUEST, { email, password });
        if (redirect !== 'admin') {
          await this.$store.dispatch(USER_REQUEST);
          await this.$router.push(redirect);
        }
      } catch (err) {
        this.errors = [
          'Введенный пароль не подходит, либо учетная запись с таким e-mail не существует.',
        ];
      }
    },
  },
  mounted() {
    if (this.initialEmail) {
      this.$refs.inputPassword.focus();
    }
  },
  metaInfo: { title: `Вход в ${VUE_APP_TITLE}` },
  name: 'AuthPage',
  props: {
    initialEmail: { default: '', type: String },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.auth-page {
  &-forms {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    max-width: 589px;
    padding: 40px 0;
    width: 100%;
  }
  ::v-deep &__field-input {
    height: 3.5rem;
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: .5rem;
    width: 100%;
  }
  &__title {
    font-weight: 600;
    font-size: 50px;
    line-height: 60px;
    color: #000000;
    font-family: 'Lato', sans-serif;
    margin: 0 auto 40px 0;
  }
  &__link {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    margin: 0 0 0 auto;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  &__button {
    @include buttons.btn-blue(280px, 70px, 20px);
    margin: 40px 0;
    width: min(100%, 280px);
  }
  &__description {
    color: #000000;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    margin: 0 auto 10px 0;
    a {
      text-decoration: none;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__apps {
    margin: 30px auto 0 0;
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
  }
}
@media screen and (max-width: 1200px) {
  .auth-page  {
    &-forms {
      justify-content: flex-start;
      margin: 30px auto 0 auto;
      padding: 0 20px 40px;
    }
  }
}
@media screen and (max-width: 480px) {
  .auth-page {
    &-forms {
      margin: 30px auto 100px auto;
    }
    &__title {
      font-size: 28px;
      line-height: 30px;
      margin: 0 auto 20px 0;
    }
  }
}
</style>
